import { render, staticRenderFns } from "./IconBetaEnquete.vue?vue&type=template&id=5ac367c7&"
import script from "./IconBetaEnquete.vue?vue&type=script&lang=ts&"
export * from "./IconBetaEnquete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports